"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _components = require("@ori-ui/mui-bundle/lab/components");
Object.keys(_components).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _components[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _components[key];
    }
  });
});
//# sourceMappingURL=lab.js.map